'use client'
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box, Flex } from '@chakra-ui/layout';
import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import { Button, IconButton } from '@chakra-ui/button';
import { MdAdd, MdCheck, MdMore } from 'react-icons/md';
import usePersonaApi from '../lib/usePersonaApi';
import { forwardRef } from '@chakra-ui/system';
import { AuthContext } from '../../auth/lib/authContext';
import { Select } from 'chakra-react-select';
import useTranslation from '../../lib/i18n/useTranslation';
const PersonaForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    formState: { isSubmitting, isDirty, isValid }
  } = useForm();
  const {
    profile
  } = useContext(AuthContext);
  const personaApi = usePersonaApi();
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      let newPersona;
      if (name) {
        newPersona = await personaApi.insertPersona(name);
      }
      if (onSubmitted && newPersona) {
        onSubmitted(newPersona);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <Flex
            flexDirection={"column"}
            alignItems={"flex-start"}
            gap={1}
          >
            <FormControl isInvalid={errors && errors.name}>
              <Input
                placeholder={t('common.namePlaceholder')}
                {...register('name', {
                  required: true,
                  minLength: 3
                })}
              />
              <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
            </FormControl>
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='primary'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </form>
      </Box>
    </>
  );
});
export default PersonaForm;
